<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="!type ? 'Log Issue' : getTitle()" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @if (!addressId) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Where do you want to log the issue?'" />
        </tidy-row>
        <tidy-card>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/home.svg'"
                [label]="'Select property'"
                [form]="form.controls.address"
                formControlName="address"
                errorMessage="Please select a property."
                [submitted]="addressSubmitted"
                [items]="addressFilter" />
            </tidy-row>
          </form>
        </tidy-card>
        <tidy-button
          [text]="'Next'"
          [action]="boundSelectAddress"
          class="primary" />
      }
      @if (!type && addressId) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'What do you want to log?'" />
        </tidy-row>
        <tidy-card>
          <tidy-card-button (action)="selectType('damage')">
            <tidy-row>
              <tidy-text
                [header]="'Damage'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="selectType('low_inventory')">
            <tidy-row>
              <tidy-text
                [header]="'Low Inventory'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="selectType('pest_report')">
            <tidy-row>
              <tidy-text
                [header]="'Pest Report'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="selectType('utility_issue')">
            <tidy-row>
              <tidy-text
                [header]="'Utility Issue'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="selectType('other')">
            <tidy-row>
              <tidy-text
                [header]="'Other'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
      @if (type && addressId) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'After logging an issue you can mark it as resolved.'" />
        </tidy-row>
        <tidy-card>
          <form [formGroup]="form">
            <tidy-row class="field-top-padding">
              <tidy-input
                [label]="'Description'"
                [icon]="'assets/svg/information-circle.svg'"
                formControlName="description"
                [form]="form.controls.description"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description.'" />
            </tidy-row>
          </form>
        </tidy-card>
        <tidy-row>
          <tidy-text
            [actionBody]="'Add Photo'"
            (action)="addAttachment()"
            class="link" />
        </tidy-row>
        @if (attachments?.length) {
          <tidy-row class="field-top-padding">
            <tidy-row>
              <tidy-text
                [body]="'Photos:'" />
            </tidy-row>
            @for (attachment of attachments; track attachment; let i = $index) {
              <tidy-row>
                <tidy-text
                  [body]="'Photo'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="((i | translate) + (1 | translate)) + ' '" />
                  <tidy-text
                    [actionBody]="'remove'"
                    (action)="removeAttachment(i)"
                    class="link red" />
                </tidy-row>
              }
            </tidy-row>
          }
          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }
          <tidy-button
            [text]="'Log Issue'"
            [action]="boundSend"
            class="primary" />
        }
      }
    </tidy-wrapper>
  </ng-template>

  <app-scroll-wrapper [templateContent]="content" />
